module.exports = __webpack_public_path__ + "static/media/pearlenterprises.ea581460.jpeg";